import React, { FC } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { TextShadow } from "./TextShadow";

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

interface LoadingProps {
  size?: string | number;
  text?: string;
}

const LoadingComponent: FC<LoadingProps> = ({ size, text }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: size }} spin />;
  return (
    <LoadingContainer>
      <Spin indicator={antIcon} />
      <TextShadow fontSize="1rem" style={{ marginTop: 16 }}>
        {text}
      </TextShadow>
    </LoadingContainer>
  );
};

LoadingComponent.defaultProps = {
  size: 32,
};

export default LoadingComponent;
